/* eslint-env jest */
import yearbookBand from './yearbookBand';

// The senior favorites gallery orders poses yearbook-formal -> cap & gown -> other,
// keyed off the garment classifier's yearbook_attire. nil sits with the formal band
// (fail-open), and a saved yearbook pose always leads.
describe('yearbookBand', () => {
  it('puts tuxedo and black_drape in band 0', () => {
    expect(yearbookBand({ id: 1, yearbookAttire: 'tuxedo' })).toBe(0);
    expect(yearbookBand({ id: 2, yearbookAttire: 'black_drape' })).toBe(0);
  });

  it('puts unclassified (null / missing) in band 0', () => {
    expect(yearbookBand({ id: 3, yearbookAttire: null })).toBe(0);
    expect(yearbookBand({ id: 4 })).toBe(0);
  });

  it('puts cap_and_gown in band 1', () => {
    expect(yearbookBand({ id: 5, yearbookAttire: 'cap_and_gown' })).toBe(1);
  });

  it('puts street_clothes and other in band 2', () => {
    expect(yearbookBand({ id: 6, yearbookAttire: 'street_clothes' })).toBe(2);
    expect(yearbookBand({ id: 7, yearbookAttire: 'other' })).toBe(2);
  });

  it('keeps the selected yearbook pose in band 0 even if its attire is not formal', () => {
    expect(yearbookBand({ id: 8, yearbookAttire: 'street_clothes' }, 8)).toBe(0);
    expect(yearbookBand({ id: 9, yearbookAttire: 'cap_and_gown' }, 9)).toBe(0);
  });

  it('does not treat a null id as the selected pose', () => {
    expect(yearbookBand({ id: null, yearbookAttire: 'street_clothes' }, null)).toBe(2);
  });
});
